import { z } from 'zod/v3';
import { AlgorithmTargetRuleType } from '../../../../dataobject/types';
import { errorMap } from '../../../../common/utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetValidFormDataSchema.translations.json';
import { AlgorithmSourceFormDataSchema } from '../../sources/schema/AlgorithmSourceFormDataSchema';
import { AlgorithmMappingQueryDtoSchema } from '../../mappings/schema/AlgorithmMappingQueryDtoSchema';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-target-rule-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmTargetRuleBaseValidFormDataSchema = z.object({
  id: z.number(),
  ruleCode: z.string(),
  sourceItemCode: z.string().nullish(),
  subjectFieldCodeId: z.number().nullish(),
  algorithmSourceId: z.number().nullish(),
  algorithmSource: AlgorithmSourceFormDataSchema.nullish(),
  algorithmMappingId: z.number().nullish(),
  algorithmMapping: AlgorithmMappingQueryDtoSchema.nullish(),
  dimensionIndicators: z.array(
    z.string(),
    errorMap(() => t('validation.dimensionIndicators.required')),
  ),
});

const AlgorithmTargetRuleBaseRuleTypeValidFormDataSchema =
  AlgorithmTargetRuleBaseValidFormDataSchema.extend({
    ruleType: z.literal(AlgorithmTargetRuleType.RULE),
    expression: z.string(errorMap(() => t('validation.expression.required'))),
    sourceItem: z.string().nullish(),
  });

const AlgorithmTargetRuleBaseMapTypeValidFormDataSchema =
  AlgorithmTargetRuleBaseValidFormDataSchema.extend({
    ruleType: z.literal(AlgorithmTargetRuleType.MAP),
    expression: z.string().nullish(),
    sourceItem: z.string(errorMap(() => t('validation.sourceItem.required'))),
  });

export const AlgorithmTargetRuleValidFormDataSchema = z.discriminatedUnion(
  'ruleType',
  [
    AlgorithmTargetRuleBaseRuleTypeValidFormDataSchema,
    AlgorithmTargetRuleBaseMapTypeValidFormDataSchema,
  ],
);
